import { flexibleUrl } from '@basqet-dashboard/common/utils/url-validator';
import * as yup from 'yup';

export const businessDetailsSchema = yup.object({
  operating_business_name: yup.string().required('Operating business name is required'),
  industry: yup.string().required('Industry is required'),
  custom_industry: yup.string().when('industry', {
    is: 'other',
    then: (schema) => schema.required('Please specify your industry'),
    otherwise: (schema) => schema.optional()
  }),
  nature_of_business: yup.string().required('Nature of business is required'),
  business_address: yup.string().required('Business address is required'),
  country: yup.string().nullable().required('Country is required'),
  monthly_volume: yup.string().required('Monthly transaction volume is required'),
  website_link: flexibleUrl(yup.string()).optional().nullable()
});
